<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_viii"></a><a id="page_ix"></a><a id="page_x"></a>PHILOSOPHY, FEMINISM,<br/>AND FAITH</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?223e9e0a